import gql from 'graphql-tag'

export const QUERY = gql`
  {
      auth{
        isLoggedIn @client 
      }
    # @client를 안하면 react apollo가 query를 api로 보내려고 할 것 이다.
  }
`;